import React, {Component} from 'react'
import {connect} from 'react-redux'
import {Form, Errors, Control} from 'react-redux-form'
import {Row, Col, Checkbox} from 'react-bootstrap'
import LayoutContainer from "../layout/layout-container/index";
import ErrorMessages from '../login/error-messages'
import UserTitleSelector from '../common/form/user/user-title-selector'
import UserFirstNameInput from '../common/form/user/user-first-name-input'
import UserLastNameInput from '../common/form/user/user-last-name-input'
import DateOfBirthSelector from '../common/form/user/date-of-birth-selector'
import Can, {checkPermission} from "../common/guards/can";
import RequiredInput from '../common/form/elements/required-input';

class ViewUserDetailsForm extends Component {

  constructor(props) {
    super(props);
  }

  updateErrors = (field, value) => {
    this.setState({
      [field]: value
    });
  };

  render() {
    return (
      <LayoutContainer>
        <Form model="deep.personal_rewards"
              className="user-details-form">
          <Errors className="errors" model="deep.personal_rewards" component={ErrorMessages}/>
          <Row>
            <Col lg={6}>
              <UserTitleSelector disabled/>

              <UserFirstNameInput readOnly/>

              <UserLastNameInput readOnly/>

              <DateOfBirthSelector disabled/>

              <RequiredInput model=".email"
                             placeholder="email"
                             label="Email address"
                             readOnly/>

              <RequiredInput model=".mobile"
                             placeholder="mobile"
                             label="Mobile number"
                             readOnly/>
            </Col>

            <Col lg={6}>
              <RequiredInput model=".store_name"
                             placeholder="Store name"
                             controlId="store_name"
                             label="Store name"
                             readOnly/>
              <RequiredInput model=".address_1"
                             placeholder="Address line 1"
                             label="Address line 1"
                             controlId="personal_address_1"
                             readOnly/>

              <RequiredInput model=".address_2"
                             placeholder="Address line 2"
                             label="Address line 2"
                             controlId="personal_address_2"
                             readOnly/>

              <RequiredInput model=".town"
                             placeholder="Town"
                             label="Town"
                             controlId="personal_address_3"
                             readOnly/>

              <RequiredInput model=".county"
                             placeholder="County"
                             label="County"
                             controlId="personal_address_4"
                             readOnly/>

              <RequiredInput model=".eircode"
                             placeholder="Eircode"
                             label="Eircode"
                             controlId="eircode"
                             readOnly/>

            </Col>

          </Row>
        </Form>
      </LayoutContainer>
    )
  }
}

const mapStateToProps = (state) => {
  return {};
};

export default connect(mapStateToProps)(ViewUserDetailsForm);


// WEBPACK FOOTER //
// ./src/components/personal-rewards/ppc-user-form.jsx